import React from "react";
import { general } from "../../locales/general";
import { Chip } from "../../helpers/general";
import { cardStyle } from "../../pages/Places/PlacesTable";
import Pagination from "../ui/Pagination";
import RenderTable from "../ui/RenderTable";
import ReviewTable from "./tables/RidesReviewsTable";

interface Props {
  data: any;
  isLoading: boolean;
  filters: any;
  onPageChange: (page: number) => void;
  deleteReview: (id: string) => void;
  isDeletingReview: boolean;
}

export const RideReviewsTab: React.FC<Props> = ({
  data,
  isLoading,
  filters,
  onPageChange,
  deleteReview,
  isDeletingReview,
}) => {
  const total = data?.meta?.totalItems ?? 0;
  const totalPages = data?.meta?.totalPages ?? 0;

  return (
    <div>
      {/* Title + count */}
      <div className="d-flex align-items-center gap-2 mb-3 ms-4">
        <h5 className="fs-5 fw-bold mb-0">Avis des trajets</h5>
        {data?.meta && <Chip tone="warning">{total} avis</Chip>}
      </div>

      {/* Table */}
      <div style={{ ...cardStyle, padding: 0, overflow: "hidden" }}>
        <RenderTable
          loading={isLoading && total === 0}
          render={() =>
            total > 0 ? (
              <ReviewTable
                reviews={data.items}
                deleteReview={deleteReview}
                isDeletingReview={isDeletingReview}
              />
            ) : (
              <p className="text-center text-muted py-5 mb-0">
                {general.fr.noData}
              </p>
            )
          }
        />
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={filters.page}
          onPageChange={onPageChange}
          totalCount={totalPages}
          pageSize={filters.limit}
          siblingCount={1}
        />
      )}
    </div>
  );
};
